class StepLearningGoalsService {
    constructor($http, $state, $q, $stateParams, $mdDialog, $mdToast) {
        this.$http = $http;
        this.$state = $state;
        this.$q = $q;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.evaluationId = $stateParams.id;
        this.index = 0;
        this.displayPromptOnRedirct = true;
        this.getAllSkills();
    }

    setSubjectAreaData(evaluationData, isMini) {
        return this.$http({
            method: 'POST',
            url: `../api/mini/${this.evaluationId}/subject_areas`,
            data: evaluationData,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((response => response.data), (error => this.$q.reject(error)));
    }

    updateExcludeField(evaluationId, skillId, exclude) {
        return this.$http({
            method: 'POST',
            url: `../api/evaluation/${evaluationId}/learning_goals/exclude`,
            data: {
                skillId,
                exclude,
            },
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((response => response.data), (error => this.$q.reject(error)));
    }

    saveLearningGoals(learningGoals, evaluationId) {
        return this.$http({
            method: 'POST',
            url: `../api/mini/${evaluationId}/learning_goals`,
            data: learningGoals,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then(response => response.data)
            .catch(err => this.$q.reject(err));
    }

    getAllSkills() {
        return this.$http({
            method: 'GET',
            url: './api/subject_area',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
            data: {},
        })
            .then((response) => {
                this.defaultSubjectAreas = response.data.filter(e => e.isDefault);
                return response.data;
            }).catch(response => this.$q.reject(response));
    }

    sendChoosenSkills(data, isMini) {
        return this.setSubjectAreaData(data, isMini);
    }

    sendCurrentTabSkills(data, isMini, redirect) {
        this.setSubjectAreaData(data, isMini)
            .then(() => {
                const stateMode = isMini ? 'mini' : 'evaluation';
                const isLastIndex = this.defaultSubjectAreas.length &&
                    data.subjectArea === this.defaultSubjectAreas[[this.defaultSubjectAreas.length - 1]].id;
                const currentIndex = this.defaultSubjectAreas.findIndex(x => x.id === data.subjectArea);
                this.displayPromptOnRedirct = false;
                this.$mdToast.show(
                    this.$mdToast.simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass("success-toast"),
                );
                if (redirect) {
                    if (isLastIndex) {
                        this.$state.go(
                            stateMode !== 'mini' ? `${stateMode}.pedagogicalApproach.subjectArea` : `mini.newMiniPedagogicalApproach`,
                            { id: this.evaluationId, reload: true },
                        );
                    } else {
                        this.$state.go(`${stateMode}.learningGoals.defaultSubjectArea`, {
                            id: this.evaluationId,
                            subjectAreaId: this.defaultSubjectAreas[currentIndex + 1].id,
                            reload: true,
                        });
                    }
                }
            })
            .catch((err) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent: `Your data has not been saved. Please try again.`,
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(err);
            });
    }

    getSkillsFromLearningArea(id) {
        return this.$http({
            method: 'GET',
            url: `./api/subject_area/${id}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
            data: {},
        })
            .then(response => response.data)
            .catch(err => this.$q.reject(err));
    }
}

export default StepLearningGoalsService;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/services/stepLearningGoalsService.js